import { Attr, BelongsTo, HasMany, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type OrganisationContract from "./OrganisationContract";
import type OrganisationsFeature from "./OrganisationsFeature";
import type Version from "./Version";

@Model()
class OrganisationFeatureAllowance extends ApplicationRecord {
  static jsonapiType = "organisation_feature_allowances";

  @Attr() blockInvoice: boolean;

  @Attr() blockInvoiceReason: string;

  @Attr() monthlyCredits: number;

  @BelongsTo() organisationContract: OrganisationContract;

  @Attr() organisationContractId: number;

  @BelongsTo() organisationsFeature: OrganisationsFeature;

  @Attr() organisationsFeatureId: number;

  @Attr() unlimited: boolean;

  @HasMany() versions: Version[];
}

export default OrganisationFeatureAllowance;
